module.exports = "/assets/data/a68732681ae8c192d4d8d6c23c794c7d-KA18.data.json";